import { I18nt } from 'utils';
import styles from './ExamenesLab.module.less';
import BannerWithImage from 'components/BannerWithImage';
import {
	ExclamationCircleOutlined,
	ArrowLeftOutlined,
	MinusCircleFilled,
	PlusCircleFilled,
} from '@ant-design/icons';
import CalendarDesc from 'components/Icons/CalendarDesc';
import CalendarAsc from 'components/Icons/CalendarAsc';
import { useExamenesLabCtx } from '../ExamenesLabContext';
import ResultadoCard from '../components/ResultadoCard';
import { Button } from 'antd';
import cn from 'classnames';
import { ResultadoExamen } from 'utils/interfaces';

function TusResultados() {
	const {
		medico,
		resultados,
		dispatch,
		nombrePaciente,
		perPage,
		totalPages,
		resultsInPage,
		sortResultados,
	} = useExamenesLabCtx();

	const ResultadosCards = () => {
		const getTime = (d: string) => new Date(d).getTime();
		const resultadoCard = (resultado: ResultadoExamen) => (
			<ResultadoCard key={resultado.idDetalle} resultado={resultado} />
		);

		const sorted = resultsInPage.sort((a, b) => {
			if (getTime(a.fecha) > getTime(b.fecha)) {
				return 1;
			}
			if (getTime(a.fecha) < getTime(b.fecha)) {
				return -1;
			}
			return 0;
		});

		if (sortResultados) {
			return sorted.map(resultadoCard);
		}
		return [...sorted].reverse().map(resultadoCard);
	};

	const actionButtons = () => {
		if (resultados.length === 0) {
			return null;
		}

		if (resultados.length <= perPage) {
			return null;
		}

		if (totalPages > 1 && resultsInPage.length === resultados.length) {
			return (
				<Button
					onClick={() => {
						dispatch({ type: 'resetPage' });
					}}
					type='link'
				>
					<MinusCircleFilled />
					{I18nt('ver_menos')}
				</Button>
			);
		}

		return (
			<Button
				onClick={() => {
					dispatch({ type: 'nextPage' });
				}}
				type='link'
			>
				<PlusCircleFilled />
				{I18nt('ver_mas')}
			</Button>
		);
	};

	return (
		<BannerWithImage className={cn(styles.resultsView, 'pt-8')}>
			<div className={styles.resultsWrapper}>
				<Button
					type='link'
					className={styles.goBackBtn}
					onClick={() => dispatch({ type: 'setView', payload: 'response' })}
				>
					<ArrowLeftOutlined />
					&nbsp;
					{I18nt('regresar')}
				</Button>
				<div className={styles.header}>
					<div className={styles.headerText}>
						<h4>{I18nt('tus_resultados')}</h4>
						<div className={styles.reminderBox}>
							<ExclamationCircleOutlined />
							<p>{I18nt('recuerda_que_hay_examenes')}</p>
						</div>
						<p className={styles.paciente}>
							<span>{`${I18nt('paciente')}: `}</span>
							{nombrePaciente}
						</p>
					</div>
					<div className={styles.headerActions}>
						<div
							className={styles.actionButton}
							onClick={() => {
								dispatch({
									type: 'sortResultados',
									payload: !sortResultados,
								});
							}}
						>
							{sortResultados ? <CalendarAsc /> : <CalendarDesc />}
							<p>{I18nt('ordenar')}</p>
						</div>
					</div>
				</div>
				<div className={styles.citasList}>
					<span className={styles.titleExamenes}>
						<strong>{I18nt('medico').toUpperCase()}: &nbsp;</strong>
						<span>{medico}</span>
					</span>
					{ResultadosCards()}
				</div>
				<div className={styles.actionButtonsContainer}>{actionButtons()}</div>
			</div>
		</BannerWithImage>
	);
}

export default TusResultados;
